module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/F3JPlb/tc-custom/9781400311149.jpg?1708485648907",
      "alt": "This image is the cover for the book 100 Days of Thanks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("100 Days of Thanks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Focus on the things that bring you joy with "), _c('i', [_vm._v("100 Days of Thanks. ")]), _vm._v("Short inspirational readings, space to record your thoughts, and brief Scripture references in a high-designed four-color gift book will help you find a peaceful, happier life.")])]), _c('p', [_vm._v("The rush of a busy schedule, a barrage of disheartening news stories, and the wear and tear of everyday life can be enough to drag anyone down. Simply pausing to recognize and express thanks for the good gifts that surround you has proven to make a major difference in happiness, peace, and contentment.")]), _c('p', [_c('i', [_vm._v("100 Days of Thanks")]), _vm._v(", a beautifully designed inspirational book of short readings, Scripture verses, and journaling space is the perfect tool to promote Christian mindfulness and gratitude. Whether you are looking for a thoughtful gift to encourage a loved one or a simple tool to create a habit of thankfulness, this lovely little book is a wonderful place to start.")]), _c('p', [_vm._v("Take a few moments out of your day to be grateful and feel your burdens get a little lighter, starting today. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Thomas Nelson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0